import { render, staticRenderFns } from "./CompTela.vue?vue&type=template&id=5e7a31c8&"
import script from "./CompTela.vue?vue&type=script&lang=js&"
export * from "./CompTela.vue?vue&type=script&lang=js&"
import style0 from "./CompTela.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports